

export default {
  data() {
    return {
      inView: false,
      success: false,
      forms: [],
      formId: 0,
      selectedForm: null,
      formData: {},
      selectedFiles: [],
      selectedFile: null,
      pageData: null,
      formRecaptchaToken: null,
      fileRecaptchaToken: null,
      multipleMediaRecaptchaToken: null,
      recaptchaInitialized: false
    };
  },

  mounted() {
    this.getPageData();

    if (this.$isInEditMode) {
      this.getAllForms();
    }
  },

  watch: {
    selectedForm: {
      handler(newVal) {
        if (newVal && !this.recaptchaInitialized) {
          this.$nextTick(() => {
            this.initializeRecaptcha();
          });
        }
      },
      immediate: true
    }
  },

  methods: {
    initializeRecaptcha() {
      if (this.recaptchaInitialized) return;

      const elements = {
        'contact-recaptcha': 'formRecaptchaToken',
        'recaptcha-custom-form-file': 'fileRecaptchaToken',
        'recaptcha-custom-form-multiple-media': 'multipleMediaRecaptchaToken'
      };

      let allElementsExist = true;
      Object.keys(elements).forEach(id => {
        const element = document.getElementById(id);
        if (!element) {
          allElementsExist = false;
        }
      });

      if (allElementsExist) {
        Object.entries(elements).forEach(([id, tokenKey]) => {
          try {
            this.$renderRecaptcha(id);
          } catch (error) {
            console.warn(`Failed to render reCAPTCHA for ${id}:`, error);
          }
        });
        this.recaptchaInitialized = true;
      }
    },

    showSuccessPopup() {
      window.scrollTo(0, 0);
      this.success = true;
      this.$router.push('/');
    },
    getPageData() {
      if (
        this.$parent &&
        this.$parent.$parent &&
        this.$parent.$parent.pageData
      ) {
        this.pageData = this.$parent.$parent.pageData;

        if (
          this.pageData &&
          this.pageData.components &&
          this.pageData.components.length
        ) {
          this.pageData.components.forEach((data) => {
            if (data && data.linkMeta && data.linkMeta.formId) {
              const parsedId = parseInt(
                data.linkMeta.formId.replace(/(<([^>]+)>)/gi, "")
              );

              if (parsedId && parsedId > 0) {
                this.formId = parsedId;
                this.getForms();
              }
            }
          });
        }
      }
    },

    async getAllForms() {
      const body = {
        customConfig: {},
        filters: [],
        limit: 100,
        list: true,
        offset: 0,
        page: 1,
      };
      try {
        const data = await this.$axios.post(
          "/api/v1/cms/form/filter?gBoxList=true",
          body
        );
        if (data) {
          this.forms = data.data.data;
        }
      } catch (e) {
        console.log(e);
      }
    },

    async getForms() {
      try {
        const data1 = await this.$axios.get("/api/v1/cms/form/get/" + this.formId);
        if (data1 && data1.data && data1.data.data) {
          this.selectedForm = data1.data.data;
          // Initialize form data structure
          this.initializeFormData(data1.data.data.fields);
        }
      } catch (e) {
        console.error('Error fetching form:', e);
      }
    },

    initializeFormData(fields) {
      if (!fields) return;

      fields.forEach(field => {
        if (!field || !field.key) return;


        // Initialize based on field type
        switch (field.type) {
          case 'checkbox':
            this.$set(this.formData, field.key, field.options ?
              field.options.reduce((acc, option) => ({ ...acc, [option.key]: false }), {}) :
              false);
            break;
          case 'file':
            this.$set(this.formData, field.key, null);
            break;
          case 'multipleMedia':
            this.$set(this.formData, field.key, []);
            break;
          case 'multiselect':
            this.$set(this.formData, field.key, []);
            break;
          case 'radio':
            this.$set(this.formData, field.key, field.options ?
              field.options.reduce((acc, option) => ({ ...acc, [option.key]: false }), {}) :
              {});
            break;
          default:
            this.$set(this.formData, field.key, '');
        }
      });
    },

    handleCheckboxChange(fieldKey, optionKey, value) {
      if (!this.formData[fieldKey]) {
        this.formData[fieldKey] = {};
      }
      this.formData[fieldKey][optionKey] = value;

      // Get the form reference from the current active form
      const formRef = this.$refs[`contact${this.selectedForm.id}`];
      if (formRef) {
        this.setFormInputs(formRef.form, { key: fieldKey, type: 'checkbox' });
        console.log(formRef.form)
      }
    },

    handleRadioChange(fieldKey, optionKey, value) {
      if (!this.formData[fieldKey]) {
        this.formData[fieldKey] = {};
      }

      // Reset all other options in the same radio group
      Object.keys(this.formData[fieldKey]).forEach(key => {
        this.formData[fieldKey][key] = false;
      });

      // Set selected option
      this.formData[fieldKey][optionKey] = value;

      // Get the form reference from the current active form
      const formRef = this.$refs[`contact${this.selectedForm.id}`];
      if (formRef) {
        this.setFormInputs(formRef.form, { key: fieldKey, type: 'radio' });
      }
    },

    handleMultiselectChange(fieldKey, optionKey, value) {
      if (!this.formData[fieldKey]) {
        this.formData[fieldKey] = {};
      }
      this.formData[fieldKey][optionKey] = value;

      // Get the form reference from the current active form
      const formRef = this.$refs[`contact${this.selectedForm.id}`];
      if (formRef) {
        this.setFormInputs(formRef.form, { key: fieldKey, type: 'multiselect' });
      }
    },

    setFormInputs(form, field) {
      if (!form) return;

      // Handle file uploads
      if (field.type === 'file') {
        form[field.key] = this.formData[field.key];
        return;
      }

      // Handle multiple file uploads
      if (field.type === 'multipleMedia') {
        form[field.key] = Array.isArray(this.formData[field.key]) ? this.formData[field.key] : [];
        return;
      }

      // Handle checkbox with options
      if (field.type === 'checkbox') {
        const selectedOptions = Object.entries(this.formData[field.key])
          .filter(([_, value]) => value)
          .map(([key]) => key);
        form[field.key] = selectedOptions;
        return;
      }

      // Handle radio buttons
      if (field.type === 'radio') {
        form[field.key] = this.formData[field.key];
        return;
      }

      // Handle multiselect
      if (field.type === 'multiselect') {
        form[field.key] = Array.isArray(this.formData[field.key]) ? this.formData[field.key] : [];
        return;
      }

      // Handle other input types
      form[field.key] = this.formData[field.key] || null;
    },

    returnAllowedExts(field) {
      if (!field) return;

      let allowedExts;
      let index;

      if (field.validation && field.validation.length) {
        if (field.validation.length > 1) {
          index = 1;
        } else {
          index = 0;
        }

        if (typeof field.validation[index] === "string") {
          allowedExts = field.validation[index].replace("allowedExts:", "");
          allowedExts = allowedExts.replace("[", "");
          allowedExts = allowedExts.replace("]", "");
          allowedExts = allowedExts
            .split(" ")
            .map((s) => "." + s)
            .join(" ");
        }
      }

      return allowedExts;
    },

    setFiles(form, field, event) {
      this.selectedFiles = [];

      if (event && event.length) {
        event.forEach((e, index) => {
          if (this.validateFilesSize(e)) {
            this.selectedFiles.push(e);
          }
        });

        form[field.key] = event;
      } else {
        form[field.key] = null;
      }
    },

    fileUpload(event, form, field) {
      this.selectedFiles = [];
      form[field.key] = null;

      if (!event.target.files) {
        return;
      }

      const files = Array.from(event.target.files);

      if (files && files.length && this.validateFilesSize(files)) {
        files.forEach((file, index) => {
          this.selectedFiles.push(file.name);
        });
      }
    },

    validateFilesSize(files) {

      if (!files) {
        return;
      }

      let filesSize = 0;

      if (files && files.length) {
        files.forEach((file, index) => {
          filesSize += file.size;
        });
      }

      if (filesSize / 1024 ** 2 > 10) {
        this.$toast.error(this.$t("toast.fileTooBig"));
        return false;
      } else {
        return true;
      }
    },

    deleteFile(file, form, field) {

      if (!file) {
        return;
      }

      form[field.key] = form[field.key].filter(function (item) {
        return item !== file;
      });

      this.selectedFiles = this.selectedFiles.filter(function (item) {
        return item !== file;
      });

    },

    setSingleFile(form, field, event) {
      if (event && event.length) {
        const file = event[0];
        if (this.validateFilesSize(file)) {
          this.selectedFile = file;
          form[field.key] = file;
        } else {
          this.selectedFile = null;
          form[field.key] = null;
        }
      } else {
        this.selectedFile = null;
        form[field.key] = null;
      }
    },

    singleFileUpload(event, form, field) {
      this.selectedFile = null;
      form[field.key] = null;

      if (!event.target.files) {
        return;
      }

      const file = event.target.files[0];

      if (file && this.validateFilesSize(file)) {
        this.selectedFile = file;
      }
    },

    deleteSingleFile(form, field) {
      this.selectedFile = null;
      form[field.key] = null;
    },

    getSelectedOptionsText(options, selected) {
      if (!options || !Array.isArray(options)) return 'Odaberite';
      if (!selected || !Array.isArray(selected) || selected.length === 0) return 'Odaberite';

      const selectedOptions = selected.map(key => {
        const option = options.find(o => o.key === key);
        return option ? option.displayValue : '';
      }).filter(Boolean);

      return selectedOptions.length > 0 ? selectedOptions.join(', ') : 'Odaberite';
    },

    hasLongTextValidator(field) {
      if (!field.validation) return false;

      // Handle both string and array validation formats
      const validators = Array.isArray(field.validation) ? field.validation : [field.validation];

      // Find max validator in any format
      const maxValidator = validators.find(v => {
        if (typeof v === 'string') {
          return v.startsWith('max:');
        }
        return false;
      });

      if (!maxValidator) return false;

      // Extract the number after max:
      const maxLength = parseInt(maxValidator.split(':')[1]);
      return maxLength >= 200;
    },

    isFieldRequired(field) {
      if (!field || !field.validation) return false;
      return field.validation.includes('required');
    },

    async handleSubmit() {
      if (!this.formRecaptchaToken) {
        this.$toast.error(this.$t("contactForm.recaptchaRequired"));
        return;
      }

      const isValid = await this.$verifyRecaptcha(this.formRecaptchaToken);
      if (!isValid) {
        this.$toast.error(this.$t("contactForm.recaptchaInvalid"));
        this.$resetRecaptcha("contact-recaptcha");
        this.formRecaptchaToken = null;
        return;
      }

      // Submit the form
      this.$refs.form.submit();

      // Reset reCAPTCHA after successful submission
      this.$resetRecaptcha("contact-recaptcha");
      this.formRecaptchaToken = null;
    },

    async handleFileUpload(event, form, field) {
      if (!this.fileRecaptchaToken) {
        this.$toast.error(this.$t("contactForm.recaptchaRequired"));
        return;
      }

      const isValid = await this.$verifyRecaptcha(this.fileRecaptchaToken);
      if (!isValid) {
        this.$toast.error(this.$t("contactForm.recaptchaInvalid"));
        this.$resetRecaptcha("recaptcha-custom-form-file");
        this.fileRecaptchaToken = null;
        return;
      }

      this.singleFileUpload(event, form, field);
    },

    async handleMultipleMediaUpload(event, form, field) {
      if (!this.multipleMediaRecaptchaToken) {
        this.$toast.error(this.$t("contactForm.recaptchaRequired"));
        return;
      }

      const isValid = await this.$verifyRecaptcha(this.multipleMediaRecaptchaToken);
      if (!isValid) {
        this.$toast.error(this.$t("contactForm.recaptchaInvalid"));
        this.$resetRecaptcha("recaptcha-custom-form-multiple-media");
        this.multipleMediaRecaptchaToken = null;
        return;
      }

      this.fileUpload(event, form, field);
    },
  },
};
